module.exports = __webpack_public_path__ + "img/susanImg4@2x.72bf30cc.jpg";